import React from "react";
import "./SuccessModal.css";

const SuccessModal = ({ message, onClose }) => {
  return (
    <div className="success-modal-overlay">
      <div className="success-modal-container">
        <h3 className="success-modal-heading">Success</h3>

        <div className="success-modal-message">
          {message}
        </div>

        <button
          className="success-modal-button"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;